/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Out Of Stock related scripts

define('modules/Product/ProductOutOfStockService',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    /**
     * Returns input value for currently displayed inventory notification form.
     * Please note the input value is not validated, it simpy returns current value and lets you populate it again when reloading the template.
     * If you do not want to loose data provided by user when reloading "productInventoryActionOutOfStock-Tmp" template
     * please provide it in the view model as "outOfStockNotificationEmail"
     * @returns {} 
     */
    function getCurrentEmailAddress() {
        var $inventoryEmailInput = $('input#txtEmailMe');
        if ($inventoryEmailInput.length === 0) {
            Roc.Logger.info("ProductOutOfStockService: Out of Stock wrapper hasn't been found on the page");
            return null;
        }
        return $inventoryEmailInput.val();
    }

    /**
     * Subscribes for inventory notification, please provide "email" and "productId" in the request object.
     * @param {} data 
     * @returns {} 
     */
    function addInventoryNotification(request) {
        return $.ajax({
            url: apiUrl + '/api/inventory/notification/subscribe/',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request)
        });
    }

    /**
     * Removes inventory notification, please provide "email" and "productId" in the request object.
     * @param {} request 
     * @returns {} 
     */
    function removeInventoryNotification(request) {
        return $.ajax({
            url: apiUrl + '/api/inventory/notification/un-subscribe/',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request)
        });
    }

    var ProductOutOfStockService = {
        addInventoryNotification: addInventoryNotification,
        removeInventoryNotification: removeInventoryNotification,
        getCurrentEmailAddress: getCurrentEmailAddress
    };

    Roc.Logger.debug('ProductOutOfStockService.js Loaded:', ProductOutOfStockService);

    return ProductOutOfStockService;
});
